import { versionedComponent } from '@edreamsodigeo/frontend-core';

export const ITINERARY_FUNNEL_PAGE_ROUTER =
  'unch-1419-itinerary-funnel-page-router';
export const C4AR_HIDE_IF_FLEX_SELECTED_MOBILE = 'GUARD_GUARD2286';
export const C4AR_DOUBLE_SELECTION_DESKTOP = 'GUARD_GUARD2368';

export const c4arHideIfFlexSelectedABtestMobile = versionedComponent(
  C4AR_HIDE_IF_FLEX_SELECTED_MOBILE
);

export const c4arDoubleSelectionDesktop = versionedComponent(
  C4AR_DOUBLE_SELECTION_DESKTOP
);

export const aliases = [
  ITINERARY_FUNNEL_PAGE_ROUTER,
  C4AR_HIDE_IF_FLEX_SELECTED_MOBILE,
  C4AR_DOUBLE_SELECTION_DESKTOP,
];
